<template>
  <div class="finance-table finances my-2">
    <div class="my-table my-2 desktopPro">
      <div class="head">
        <div
          v-for="head_item in heads"
          :key="head_item"
          class="head_item title-blue d-inline-block"
        >
          <div class="inner-item">
            {{ head_item }}
          </div>
        </div>
      </div>
      <div class="head">
        <div class="head_item title-blue d-inline-block">
          <div class="inner-item">
            {{ accounting.seller_name }}
          </div>
        </div>
        <!-- <div class="head_item title-blue d-inline-block">
          <div class="inner-item">
            {{ accounting.order_sum }}
          </div>
        </div> -->
        <div class="head_item title-blue d-inline-block">
          <div class="inner-item">
            {{ accounting.order_sum}}
          </div>
        </div>
        <div class="head_item title-blue d-inline-block">
          <div class="inner-item">
            {{accounting.golpino_deposit_sum }}
          </div>
        </div>
        <div class="head_item title-blue d-inline-block">
          <div class="inner-item">
            {{accounting.account_remain }}
          </div>
        </div>
        <div class="head_item title-blue d-inline-block">
          <div class="inner-item w-100">
            <router-link :to="'finances/finances-details'">
              <button type="button" class="btn">جزئیات</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="mobilePro px-2">
      <div class="mb-2 mobile-finance">
        <div class=" my-rounded">
          <div class="mx-2 text-color text-center">
            <div class="d-inline-block p-3 my-2">
              <h6>مانده حساب شما (تومان)</h6>
              <div class="text-center mb-2 purple-box">
                {{ accounting.account_remain ? accounting.account_remain : 0 }}
              </div>
              <div class="mb-2 my-title-3">
                <div class="d-inline-block align-top text-right">
                  <div class="pt-2 font">مجموع سفارشات:</div>
                  <div class="pt-2 font">مجموع واریز گلپینو:</div>
                </div>
                <div class="d-inline-block align-top text-left">
                  <div class="pt-1 mx-2">
                    {{ accounting.order_sum }}
                  </div>
                  <div class="pt-1 mx-2">
                    {{ accounting.golpino_deposit_sum }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="(account, index) in detail_accounting"
        :key="index"
        class="mb-2 mobile-finance"
      >
        <FinanceMobileView
          @get_modal="get_modal"
          browser-size="mobile"
          :transaction="account"
        />
        <v-dialog v-model="modal_on" width="70%">
          <v-card class="p-4 text-color">
            <div class="img-wrapper mb-3">
              <img src="../../../../public/img/images/buy.jpg" alt="" />
            </div>
            <div class="my-title-3">
              <div class="text-center mb-1">
                <div class="d-inline-block right-part">مبلغ فاکتور :</div>
                <div class="d-inline-block right-part">
                  <span class="mx-1"> {{ show_data.payable }}</span>
                  <span>تومان</span>
                </div>
              </div>
              <div class="text-center mb-1">
                <div class="d-inline-block right-part">هزینه ارسال :</div>
                <div class="d-inline-block right-part">
                  <span class="mx-1"> {{ show_data.delivery_cost }}</span>
                  <span>تومان </span>
                </div>
              </div>
              <div class="text-center mb-1">
                <div class="d-inline-block right-part">تخفیف :</div>
                <div class="d-inline-block right-part">
                  <span class="mx-1"> {{ show_data.discount }}</span>
                  <span>تومان </span>
                </div>
              </div>
              <div class="text-center mb-1">
                <div class="d-inline-block right-part">درصد گلپینو :</div>
                <div class="d-inline-block right-part">
                  <span class="mx-1"> {{ show_data.golpino_commission }}</span>
                  <span>تومان </span>
                </div>
              </div>
              <div class="text-center mb-1">
                <div class="d-inline-block mx-2">قابل پرداخت :</div>
                <div class="d-inline-block mx-2">
                  <span class="mx-1"> {{ show_data.seller_income }}</span>
                  <span>تومان </span>
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>

import Service from "../../../utils/seller-service";
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import FinanceMobileView from "./FinanceMobileView.vue";
import SeparatorNumber from "../../../../src/utils/MyTools";
export default {
  components: {
    FinanceMobileView,
  },
  setup() {
    // intro
    const heads = ref({
      seller_name: "نام",
      order_sum: "مجموع سفارشات",
      golpino_deposit_sum: "مبلغ واریز شده",
      account_remain: "مانده",
      detailes: "جزئیات",
    });
    const item = ref({
      date: "1400/12/02",
      factor_number: "1500",
      ducoment_number: "11",
      golpino_pay: "8000",
    });

    const search_store = ref();
    const accounting = ref({});
    const transactions = ref(null);
    const Separator_Number = function () {
      accounting.value.account_remain = SeparatorNumber (accounting.value.account_remain);
      accounting.value.order_sum = SeparatorNumber (accounting.value.order_sum);
      accounting.value.golpino_deposit_sum = SeparatorNumber (accounting.value.golpino_deposit_sum);
      accounting.value.order_sum = SeparatorNumber (accounting.value.order_sum);
      accounting.value.golpino_deposit_sum = SeparatorNumber (accounting.value.golpino_deposit_sum);
      accounting.value.account_remain = SeparatorNumber (accounting.value.account_remain);
    };
    // functions
    const authService = computed(() => {
      return Service(true);
    });
    //
    const depositeActive = ref(true);
    const withdrawActive = ref(false);
    const as_deposite = function (this_row) {
      this_row.depositeActive = true;
      this_row.withdrawActive = false;
    };
    const as_withdraw = function (this_row) {
      this_row.depositeActive = false;
      this_row.withdrawActive = true;
    };
    //
    const modal_on = ref(false);
    const show_data = ref({});

    const get_modal = function (modal_data) {
      modal_on.value = !modal_on.value;
      show_data.value = modal_data.show_data;
      console.log("show_data.value");
      console.log(show_data.value);
    };

    //
    const show_my_submit = ref();
    const show_submit = function (this_row) {
      this_row.show_my_submit = this_row.id;
    };
    const hide_submit = function (myData) {};

    const detail_accounting = ref({});
    // mounte
    onMounted(() => {
      authService.value.receive(
        "seller/accounting",
        {},
        (s, d) => {
          if (s == 200) {
            accounting.value = d.data;
            console.log();
            Separator_Number();
          }
        },
        (s, e) => {}
      );
      authService.value.receive(
        "seller/accounting/detail",
        {},
        (s, d) => {
          if (s == 200) {
            detail_accounting.value = d.data;
          }
        },
        (s, e) => {}
      );
    });

    // returns
    return {
      detail_accounting,
      heads,
      accounting,
      transactions,
      search_store,
      as_deposite,
      as_withdraw,
      depositeActive,
      withdrawActive,
      show_submit,
      hide_submit,
      show_my_submit,
      get_modal,
      modal_on,
      show_data,
      Separator_Number
    };
  },
};
</script>

<style lang="scss" scoped>
.finances{
   .font {
    font-size: 13px;
  }
}
.finance-table {
  border-radius: 10px;
  font-weight: lighter;
}
.my-table {
  background: #fff;
  border-radius: 10px;
  overflow: auto;
  // border: solid 1px #f7befd;
  box-shadow: 1px 1px 3px #ffc4fe8c;
  .head,
  .body-table {
    text-align: right;
  }
  background: #fff;
  .head {
    background: rgb(235, 235, 235);
  }
  .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
    background: rebeccapurple;
  }
}
.auto-table {
}
.search {
  background: #defffd;
}

.head_item {
  background: #f8fcff;
  text-align: center;
  width: calc(100% / 5);
  border: solid 1px #fff;
  line-height: 1.2;
  font-size: 12px;
  font-weight: bold;
  color: #0531b9;
  min-height: 59px;
  vertical-align: top;
  position: relative;

  &:last-child {
    border-left: solid 1px #fce3ff;
  }
  &.item {
    color: #3f51b5;
    font-weight: 400;
  }
}
.table_item {
  background: #f8fcff;
  text-align: center;
  width: calc(100% / 6);
  border: solid 1px #fff;
  line-height: 1.2;
  font-size: 11px;
  min-height: 150px;
  vertical-align: top;
  position: relative;
  color: #1e2027;
}
.inner-item {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
}
.comment-reply {
  background-color: #ece8e8;
  border-radius: 4px;
}

.two-state-btn {
  padding: 10px;
  background: rgb(104, 104, 104);
  outline: none;
  &.admin {
    background: #ef85ba4d;
    &.active {
      font-weight: bold;
      background: #eb55a0;
      color: white;
      box-shadow: 1px 1px 5px #1b2d75;
    }
  }
  &.seller {
    background: #85cdef3a;
    &.active {
      font-weight: bold;
      background: #93dbfc;
      color: white;
      box-shadow: 1px 1px 5px #1b2d75;
    }
  }
}
.side {
  margin: 0 -3px;
}
.out-none {
  outline: none;
}
.submit {
  padding: 5px;
  color: white;
  outline: none;
  width: 100%;
  background: #0a77cd;
  &:hover {
    background: #2196f3;
  }
}
.amount-input {
  border: solid 1px rgb(231, 231, 231);
}
.img-wrapper {
  width: 60px;
  margin: 0 auto;
  img {
    width: 100%;
  }
}
.purple-box {
  background: #fce3ff;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 20px;
}
</style>